import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { SvgIconComponent } from 'angular-svg-icon';

import { TransactionStatus } from './transaction-status.const';
import { PlainTooltipDirective } from '@app/shared/components/tooltip/plain-tooltip/plain-tooltip.directive';

const ICONS_FOLDER = '/assets/icons/';
const ICON_SIZE_FOLDER = 24;

@Component({
  selector: 'history-transaction-status',
  templateUrl: './transaction-status.component.html',
  styleUrls: ['./transaction-status.component.css'],
  imports: [CommonModule, SvgIconComponent, PlainTooltipDirective],
})
export class HistoryTransactionStatusComponent {
  @Input() status = '';
  @Input() small = false;

  protected readonly TransactionStatus = TransactionStatus;

  iconFolder = `${ICONS_FOLDER}${ICON_SIZE_FOLDER}/`;

  constructor(public translate: TranslateService) {}

  getTransactionStatusTranslation(status: string): string {
    const key = `transaction-history.status.${status}`;
    const translation = this.translate.instant(key);
    return key === translation ? status : translation;
  }
}
